module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "successHolder"
  }, [_c('div', {
    staticClass: "drpAllImgSvg successImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "submittedTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.success_msg")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a78d87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Success.vue
// module id = 162
// module chunks = 1